import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";
export const findSourceOrganization = createAsyncThunk(
  "users/findSourceOrganizations",
  async (searchText, { rejectWithValue, getState }) => {
    
    const state = getState() as RootState;

    try {
      const { data } = await axiosInstance.get(`${api.baseURL}userProfile?user=${state.userAuthentication.user?.id}`, {
        params: {
          populate: "sourceOrganization",
        },
      });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
